import {takeEvery, call, put} from 'redux-saga/effects';
import {
    OTHER_FEEDBACK_READ,
    OTHER_FEEDBACK_READ_REQUEST,
    OTHER_FEEDBACK_READ_SUCCESS,
    OTHER_FEEDBACK_READ_FAILURE
} from '../constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';

function* otherFeedbackRead(action: any) {

    const {profileId, feedbackId} = action;

    yield put({type: OTHER_FEEDBACK_READ_REQUEST});
    try {
        yield call(Api.fetch, {
            endpoint: `feedback/last-view/${feedbackId}`,
            method: ApiMethods.PUT
        });
        yield put({type: OTHER_FEEDBACK_READ_SUCCESS, profileId, feedbackId});
    } catch (e) {
        yield put({type: OTHER_FEEDBACK_READ_FAILURE, error: e});
    }
}

function* otherFeedbackSagaRead() {
    yield takeEvery(OTHER_FEEDBACK_READ, otherFeedbackRead);
}

export default otherFeedbackSagaRead;
